import React from 'react';
import ShiftTimePicker from '../../../components/form/ShiftTimePicker';
import Select from '../../../components/form/Select';
import trashRedIcon from '../../../assets/images/trash-red-icon.svg';

const SplitShiftSegmentRow = ({
	index,
	number,
	segment,
	shiftStart,
	shiftEnd,
	isFirst,
	isLast,
	canDelete,
	shouldShowUnits,
	unitOptions,
	startError,
	endError,
	onStartChange,
	onEndChange,
	onStartError,
	onEndError,
	onUnitChange,
	onDelete
}) => {
	const handleStartChange = (value) => onStartChange(index, value);
	const handleEndChange = (value) => onEndChange(index, value);
	const handleStartError = () => onStartError(index);
	const handleEndError = () => onEndError(index);
	const handleUnit = (payload) => onUnitChange(index, payload);
	const handleDelete = () => onDelete(index);
	const startFieldClass = startError ? 'split-shift-calendar-invalid' : '';
	const endFieldClass = endError ? 'split-shift-calendar-invalid' : '';

	return (
		<div className="split-shift-segment-row">
			<div className="split-shift-segment-number">{number}</div>
			<div className="split-shift-segment-fields">
				<div className="split-shift-segment-field">
					<div className="split-shift-field-label">Start time</div>
					<ShiftTimePicker
						value={segment.start}
						shiftStart={shiftStart}
						shiftEnd={shiftEnd}
						disabled={isFirst}
						onChange={handleStartChange}
						onInvalid={handleStartError}
						className={startFieldClass}
						panelClassName="split-shift-calendar-panel"
					/>
					{startError && <div className="split-shift-error">{startError}</div>}
				</div>
				<div className="split-shift-segment-field">
					<div className="split-shift-field-label">End time</div>
					<ShiftTimePicker
						value={segment.end}
						shiftStart={shiftStart}
						shiftEnd={shiftEnd}
						disabled={isLast}
						onChange={handleEndChange}
						onInvalid={handleEndError}
						className={endFieldClass}
						panelClassName="split-shift-calendar-panel"
					/>
					{endError && <div className="split-shift-error">{endError}</div>}
				</div>
				{shouldShowUnits && (
					<div className="split-shift-segment-field">
						<div className="split-shift-field-label">
							<span>Unit</span>
							<span className="split-shift-field-optional">(Optional)</span>
						</div>

						<Select
							className="split-shift-segment-unit"
							placeholder="Select..."
							name="unitId"
							value={segment.unitId || null}
							handleChange={handleUnit}
							options={unitOptions}
						/>
					</div>
				)}
			</div>

			<div className="split-shift-segment-actions">
				{canDelete && (
					<button type="button" className="split-shift-delete" onClick={handleDelete} aria-label="Remove segment">
						<img src={trashRedIcon} alt="Remove segment" />
					</button>
				)}
			</div>
		</div>
	);
};

export default SplitShiftSegmentRow;
